import { useMutation, UseMutationOptions, useQuery } from 'react-query';

export function useAPICallAsMutation<T, U = unknown>(
  apiCall: (data: T) => Promise<U>,
  options: UseMutationOptions<U, unknown, T, unknown>
) {
  return useMutation((data: T) => apiCall(data), options);
}

export function useAPICallAsQuery<T, U>(key: string, apiCall: (data: T) => Promise<U>, params: T) {
  return useQuery([key, params], () => apiCall(params));
}
